import React from 'react';
import styled from 'styled-components';
import PromoIcon from 'web-ui-kit/assets/PromoIcon';
import { primaryHighlightM, textPrimaryM, textDisabledM } from 'web-ui-kit/colors';
import { MQ_FOR_TABLET_LANDSCAPE_UP } from 'web-ui-kit/media';
import { toUSDString } from 'web-ui-kit/styleUtils';
import { BodySmallSmallStyles, BodySmallLargeStyles, Header3SmallStyles, Header3LargeStyles, Header4SmallStyles, Header4LargeStyles } from 'web-ui-kit/typography';

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7;
/**
 * The core product information including source, name, and price.
 */


function PrimaryInfo(_ref) {
  var _ref$showPricing = _ref.showPricing,
      showPricing = _ref$showPricing === void 0 ? false : _ref$showPricing,
      _ref$product = _ref.product,
      product = _ref$product === void 0 ? {} : _ref$product;
  var _product$name = product.name,
      name = _product$name === void 0 ? '' : _product$name,
      _product$promos = product.promos,
      promos = _product$promos === void 0 ? [] : _product$promos,
      _product$regularPrice = product.regularPrice,
      regularPrice = _product$regularPrice === void 0 ? 0 : _product$regularPrice,
      _product$salePrice = product.salePrice,
      salePrice = _product$salePrice === void 0 ? 0 : _product$salePrice,
      _product$source = product.source,
      source = _product$source === void 0 ? '' : _product$source;
  var onSale = salePrice > 0;
  var currentPrice = onSale ? salePrice : regularPrice;
  var Container = styles.Container,
      Name = styles.Name,
      Price = styles.Price,
      Pricing = styles.Pricing,
      Promos = styles.Promos,
      Source = styles.Source,
      StrikethroughPrice = styles.StrikethroughPrice;
  return (
    /*#__PURE__*/
    React.createElement(Container, {
      "data-testid": "primary-info"
    },
    /*#__PURE__*/
    React.createElement(Source, null, source),
    /*#__PURE__*/
    React.createElement(Name, null, name), showPricing &&
    /*#__PURE__*/
    React.createElement(Pricing, null,
    /*#__PURE__*/
    React.createElement(Price, {
      isOnSale: onSale
    }, toUSDString(currentPrice)), onSale &&
    /*#__PURE__*/
    React.createElement(StrikethroughPrice, null, toUSDString(regularPrice))), promos.length > 0 &&
    /*#__PURE__*/
    React.createElement(Promos, null,
    /*#__PURE__*/
    React.createElement(PromoIcon, null), copy.promos(source)))
  );
}

var copy = {
  promos: function promos(source) {
    return "".concat(source, " is currently running promotions. Any applicable promotions will be applied.");
  }
};
var styles = {
  Container: styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    display: flex;\n    flex-direction: column;\n    padding: 1rem;\n\n    ", " {\n      padding: 0;\n    }\n  "])), MQ_FOR_TABLET_LANDSCAPE_UP),
  Source: styled.p(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    ", ";\n\n    ", " {\n      ", ";\n      margin-bottom: 0.125rem;\n    }\n  "])), BodySmallSmallStyles, MQ_FOR_TABLET_LANDSCAPE_UP, BodySmallLargeStyles),
  Name: styled.p(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n    ", ";\n    margin-bottom: 0.125rem;\n\n    ", " {\n      ", ";\n      margin-bottom: 0.5rem;\n    }\n  "])), Header3SmallStyles, MQ_FOR_TABLET_LANDSCAPE_UP, Header3LargeStyles),
  Pricing: styled.div(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n    display: flex;\n    align-items: baseline;\n    margin-bottom: 0.25rem;\n\n    ", " {\n      margin-bottom: 0.75rem;\n    }\n  "])), MQ_FOR_TABLET_LANDSCAPE_UP),
  Price: styled.p(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n    ", ";\n    color: ", ";\n    margin-right: 0.25rem;\n\n    ", " {\n      ", ";\n      color: ", ";\n      margin-right: 0.5rem;\n    }\n  "])), Header4SmallStyles, function (p) {
    return p.isOnSale ? primaryHighlightM : textPrimaryM;
  }, MQ_FOR_TABLET_LANDSCAPE_UP, Header4LargeStyles, function (p) {
    return p.isOnSale ? primaryHighlightM : textPrimaryM;
  }),
  StrikethroughPrice: styled.p(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n    ", ";\n    color: ", ";\n    text-decoration: line-through;\n\n    ", " {\n      ", ";\n      color: ", ";\n    }\n  "])), BodySmallSmallStyles, textDisabledM, MQ_FOR_TABLET_LANDSCAPE_UP, BodySmallLargeStyles, textDisabledM),
  Promos: styled.div(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n    display: grid;\n    grid-template-columns: min-content 1fr;\n    grid-column-gap: 0.5rem;\n    align-items: center;\n\n    ", ";\n\n    ", " {\n      ", ";\n      margin-bottom: 1rem;\n    }\n  "])), BodySmallSmallStyles, MQ_FOR_TABLET_LANDSCAPE_UP, BodySmallLargeStyles)
};
export default PrimaryInfo;